import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=242a37b6&scoped=true&"
import script from "./Chips.vue?vue&type=script&lang=ts&"
export * from "./Chips.vue?vue&type=script&lang=ts&"
import style0 from "./Chips.vue?vue&type=style&index=0&id=242a37b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a37b6",
  null
  
)

export default component.exports